import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, mergeMap } from 'rxjs/operators'
import { MbWishlistActions } from '../actions'
import { Injectable } from '@angular/core'
import { MbWishlistConnector } from '../../connectors'
import { normalizeHttpError, SiteContextActions, withdrawOn } from '@spartacus/core'

@Injectable({
  providedIn: 'root'
})
export class WishlistEffects {

  private contextChange$ = this.actions$.pipe(
    ofType(
      SiteContextActions.CURRENCY_CHANGE,
      SiteContextActions.LANGUAGE_CHANGE
    )
  )

  loadWishList$ = createEffect(() => this.actions$.pipe(
    ofType(MbWishlistActions.LOAD_DEFAULT_WISHLIST),
    map((action: MbWishlistActions.LoadDefaultWishlist) => action?.payload),
    mergeMap(payload => this.wishlistConnector.getDefaultWishlist(payload?.userId)
      .pipe(
        mergeMap(wishlist => [new MbWishlistActions.LoadDefaultWishlistSuccess({ wishlist: wishlist, userId: payload?.userId })]),
        catchError(error =>
          of(new MbWishlistActions.LoadDefaultWishlistFail({ error: normalizeHttpError(error), userId: payload?.userId })))
      )),
    withdrawOn(this.contextChange$)
  ))

  addEntryToWishlist = createEffect(() => this.actions$.pipe(
    ofType(MbWishlistActions.ADD_ENTRY_TO_WISHLIST),
    map((action: MbWishlistActions.AddEntryToWishlist) => action?.payload),
    mergeMap(payload => this.wishlistConnector.addEntryToWishlist(payload?.productCode, payload?.userId)
      .pipe(
        mergeMap(wishlist => [
          new MbWishlistActions.AddEntryToWishlistSuccess(
          { wishlist: wishlist, productCode: payload?.productCode, userId: payload?.userId }),
          new MbWishlistActions.LoadDefaultWishlistSuccess({ wishlist: wishlist, userId: payload?.userId })
        ]),
        catchError(error => of(new MbWishlistActions.AddEntryToWishlistFail(
          { error: normalizeHttpError(error), productCode: payload?.productCode, userId: payload?.userId })))
      )),
    withdrawOn(this.contextChange$)
  ))

  removeEntryFromWishlist = createEffect(() => this.actions$.pipe(
    ofType(MbWishlistActions.REMOVE_ENTRY_FROM_WISHLIST),
    map((action: MbWishlistActions.RemoveEntryFromWishlist) => action?.payload),
    mergeMap(payload => this.wishlistConnector.removeEntryFromWishlist(payload?.productCode, payload?.userId)
      .pipe(
        mergeMap(wishlist => [
          new MbWishlistActions.RemoveEntryFromWishlistSuccess(
          { wishlist: wishlist, productCode: payload?.productCode, userId: payload?.userId }),
          new MbWishlistActions.LoadDefaultWishlistSuccess({ wishlist: wishlist, userId: payload?.userId })
        ]),
        catchError(error => of(new MbWishlistActions.RemoveEntryFromWishlistFail(
          { error: normalizeHttpError(error), productCode: payload?.productCode, userId: payload?.userId })))
      )),
    withdrawOn(this.contextChange$)
  ))

  constructor (protected actions$: Actions,
               protected wishlistConnector: MbWishlistConnector) { }
}
